import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './guard/auth';
import { NewMapComponent } from './new-map/new-map.component';

const routes: Routes = [
  { path: '', component: NewMapComponent },
  { path: 'two-worlds', loadChildren: () => import('./two-worlds/two-worlds.module').then( m => m.TwoWorldsPageModule)},
  { path: '', loadChildren: () => import('./tabs/tabs.module').then(m => m.TabsPageModule)},
  // { path: 'commerces/:id', loadChildren: () => import('./tab1/tab1.module').then(m => m.Tab1PageModule)},
  { path: 'login', loadChildren: () => import('./login/login.module').then( m => m.LoginPageModule) },
  { path: 'repartos', loadChildren: () => import('./repartos/repartos.module').then( m => m.RepartosPageModule), canActivate: [AuthGuard] },
  { path: 'register', loadChildren: () => import('./register/register.module').then( m => m.RegisterPageModule) },
  { path: 'commerce/:id', loadChildren: () => import('./commerce/commerce.module').then( m => m.CommercePageModule), canActivate: [AuthGuard] },
  { path: 'cart-orders/:commerce_id', loadChildren: () => import('./cart-orders/cart-orders.module').then( m => m.CartOrdersPageModule) },
  { path: 'notificaciones', loadChildren: () => import('./notificaciones/notificaciones.module').then( m => m.NotificacionesPageModule), canActivate: [AuthGuard] },
  { path: 'adress', loadChildren: () => import('./adress/adress.module').then( m => m.AdressPageModule), canActivate: [AuthGuard] },
  { path: 'valoration', loadChildren: () => import('./valoration/valoration.module').then( m => m.ValorationPageModule), canActivate: [AuthGuard] },
  { path: 'recover', loadChildren: () => import('./recover/recover.module').then( m => m.RecoverPageModule)},
  {
    path: 'menu/:id',
    loadChildren: () => import('./detalle/detalle.module').then( m => m.DetallePageModule),
    canActivate: [AuthGuard]
  }
];
@NgModule({
  imports: [
    BrowserModule,
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules}),
    RouterModule.forRoot(routes, { useHash : true})
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
